import React from 'react'
import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'

import { WholesalerType } from 'shared/store/useWholesalers/types'

import { WholesalerActionType } from '../../types'
import { StyledCard, StyledImg } from './styles'

type Props = {
   activeWholesaler: WholesalerType
   handleWholesaler: (wholesalerId: string, type: WholesalerActionType) => void
}
export default function NonCoopWholesalerCard({ activeWholesaler, handleWholesaler }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'WHOLESALERS'])

   return (
      <Grid size={{ xs: 6, sm: 4, md: 4, lg: 3, xl: 2 }}>
         <Tooltip
            title={t('WHOLESALERS:addingCoopTooltip') || ''}
            onClick={() => handleWholesaler(activeWholesaler.wholesaleUuid, 'addWholesaler')}
         >
            <StyledCard>
               <StyledImg
                  src={`${process.env.REACT_APP_FILES_URL}/img/logos-wholesalers/light/${activeWholesaler.wholesaleUuid}.png`}
                  alt={activeWholesaler.wholesaleName}
               />
            </StyledCard>
         </Tooltip>
      </Grid>
   )
}
